import { Component, PropSync, Vue } from "vue-property-decorator";
import { FirstTimeLogin } from "@/types/Login";
import { TCBReceiptApi } from "@/network/pb/proto";
import { Util } from "@/util";
import { Encrypt } from "@/util/Encrypt";

@Component<LightBoxFirstTime>({
    components: {}
})
export default class LightBoxFirstTime extends Vue {
    // prop in
    @PropSync("type", { type: Number })
    syncedType!: number;

    private form: FirstTimeLogin = {
        newPwd: "",
        againPwd: "",
        email: "",
        isCheck: false,
    };

    private errMsg: {
        newPwd: string,
        againPwd: string,
        email: string,
        isCheck: string,
    } = {
        newPwd: "",
        againPwd: "",
        email: "",
        isCheck: "",
    };

    // event out
    private async submit() {
        console.log("submit");

        const encoder = new TextEncoder();
        const passwordMotify = TCBReceiptApi.Protobuf.PasswordMotify.create({
            newPassword: encoder.encode(this.form.newPwd),
            etoeePassword: await Encrypt.getE2EEpd(this.form.newPwd),
            resetMail: this.form.email as string,
        });

        this.$emit("submit", passwordMotify); // 觸發的事件名稱
    }

    private validForm() {
        let isErr = false;
        this.errMsg.newPwd = "";
        this.errMsg.againPwd = "";
        this.errMsg.email = "";

        // 密碼驗證規則
        if (this.form.newPwd === "") {
            isErr = true;
            this.errMsg.newPwd = "必填"; // 請輸入至少6位(大小寫英文字母或符號)密碼
        }

        if (this.form.againPwd === "") {
            isErr = true;
            this.errMsg.againPwd = "必填";
        } else if (this.form.againPwd !== this.form.newPwd) {
            isErr = true;
            this.errMsg.againPwd = "密碼錯誤，與上方密碼不符";
        }

        // 驗證信箱規則
        if(this.syncedType !== 1211){
            if (this.form.email === "") {
                isErr = true;
                this.errMsg.email = "必填";
            } else {
                const isValidate = Util.validateEmail(this.form.email);
                if (!isValidate) {
                    isErr = true;
                    this.errMsg.email = "信箱格式錯誤";
                }
            }
        }

        if (isErr) {
            return false;
        }

        // 勾選
        if(this.syncedType !== 1211){
            if (!this.form.isCheck) {
                this.errMsg.isCheck = "請閱讀後勾選";
                return false;
            }
        }

        this.submit();
    }
}